'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'balloons';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = 'M172.8 342.4s0 0 0 0l.1-.1 .8-.6c.8-.6 2-1.6 3.6-2.8c3.1-2.6 7.8-6.4 13.3-11.4c11.2-10 26.1-24.5 40.9-42C262 249.1 288 204.5 288 160c0-70.7-57.3-128-128-128S32 89.3 32 160c0 44.5 26 89.1 56.5 125.4c14.8 17.6 29.7 32 40.9 42c5.6 5 10.2 8.8 13.3 11.4c1.6 1.3 2.8 2.2 3.6 2.8l.8 .6 .1 .1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L160 352l12.8-9.6s0 0 0 0s0 0 0 0s0 0 0 0zm-10.5 37.5l-2.3-5.7-2.3 5.7L143.3 416l33.5 0-14.4-36.1zM211.2 416L224 448l-34.5 0-59.1 0L96 448l12.8-32L128 368s-128-96-128-208C0 71.6 71.6 0 160 0s160 71.6 160 160c0 112-128 208-128 208l19.2 48zM176 112c-35.3 0-64 28.7-64 64l-32 0c0-53 43-96 96-96l0 32zm320 64c-35.3 0-64 28.7-64 64l-32 0c0-53 43-96 96-96l0 32zM448 432s-85.6-64.2-116.8-148.9c8.2-13.9 15.6-28.8 21.7-44.7c4.8 39.7 28.4 78.7 55.6 111.1c14.8 17.6 29.7 32 40.9 42c5.6 5 10.2 8.8 13.3 11.4c1.6 1.3 2.8 2.2 3.6 2.8l.8 .6 .1 .1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L480 416l12.8-9.6s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l.1-.1 .8-.6c.8-.6 2-1.6 3.6-2.8c3.1-2.6 7.8-6.4 13.3-11.4c11.2-10 26.1-24.5 40.9-42C582 313.1 608 268.5 608 224c0-70.7-57.3-128-128-128c-48.2 0-90.2 26.6-112 66c0-.7 0-1.3 0-2c0-15.5-1.7-30.7-4.9-45.2C392.3 83.5 433.9 64 480 64c88.4 0 160 71.6 160 160c0 112-128 208-128 208l19.2 48L544 512l-34.5 0-59.1 0L416 512l12.8-32L448 432zm34.3 11.9l-2.3-5.7-2.3 5.7L463.3 480l33.5 0-14.4-36.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;